import { clearUser, setUser } from "../src/actions/user";
import { Authenticator } from "../utilities/office.helpers";
import { initialState } from "../src/reducers/user";
import { deleteNamespace } from "./server";
import { store } from "../src";

class AuthService {
  authenticator: Authenticator;

  constructor() {
    this.authenticator = new Authenticator();
    this.registerProviders();
  }

  registerProviders() {
    this.authenticator.endpoints.registerMicrosoftAuth(
      "86aa5857-8533-49b1-a351-b8f24ac35889",
      {
        scope: "openid email profile",
        responseType: "id_token",
        nonce: true,
      }
    );

    this.authenticator.endpoints.registerGoogleAuth(
      "266185792476-6rh7v1ese99chhqda8850stucb1l6s0p.apps.googleusercontent.com",
      {
        scope: "openid email profile",
        responseType: "id_token",
        nonce: true,
      }
    );

    // this.authenticator.endpoints.add("Okta", {
    //   name: "Okta",
    //   clientId: environment_conf.okta_client_id,
    //   baseUrl:
    //     "https://spectaclesb2c.b2clogin.com/spectaclesb2c.onmicrosoft.com/oauth2/v2.0",
    //   authorizeUrl: "/authorize",
    //   responseType: "id_token",
    //   scope: "openid profile",
    //   extraQueryParameters: {
    //     p: "B2C_1_Okta",
    //   },
    //   nonce: true,
    //   //usePKCE: true,
    // });
  }
}

export const setAsLoggedOut = () => {
  store.dispatch(clearUser());
};

const authService = new AuthService();

export const logout = async () => {
  setAsLoggedOut();
  deleteNamespace();
  localStorage.removeItem("_message_history");
  authService.authenticator.tokens.clear();
};

export default authService;
